import { Component, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SimpleInputModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'iw-paypal-form',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SimpleInputModule,
    TranslateModule,
  ],
  templateUrl: './paypal-form.component.html',
  styleUrl: './paypal-form.component.scss',
})
export class PaypalFormComponent {
  form = input<FormGroup>();

  readonly emailErrors: Record<string, string> = {
    emailInvalid: 'withdrawal.paypal.email.error.format',
  };
}
